<template>
    <div>
        <div>
            <vue-toastr ref="notificationToast"></vue-toastr>
            <div class="ibox box-primary">
                <div class="ibox-title with-border"><h2 class="box-title">{{ title }}</h2></div>
                <div class="ibox-content">
                    <div v-if="isAdmin" class="form-group">
                        <label class="control-label">Mandant</label>
                        <Select2 v-model="record.client_id" :options="clients"/>
                    </div>
                    <div class="form-group">
                        <label>Bereichname</label>
                        <br>
                        <input name="name"
                               type="text"
                               id="name"
                               class="form-control"
                               v-model="record.name"
                               :disabled="isAdmin != 1">
                    </div>
                    <div class="form-group">
                        <label>Typ</label>
                        <a class="fa fa-question-circle" v-tippy
                           content="Definiert, in welcher Form die Contents in der App dargstellt werden."></a>
                        <br>
                        <select name="type"
                                @change="changeType"
                                id="type"
                                class="form-control"
                                v-model="record.type"
                                :disabled="isAdmin != 1">
                            <option value="feed">Feed</option>
                            <option value="list">Liste</option>
                        </select>
                    </div>
                    <hr>
                    <h3>Seitenaufbau</h3>
                    <hr>
                    <div class="col-md-12">
                        <!-- Fallback mode keeps mouse wheel scrolling working while dragging -->
                        <draggable v-model="record.elements"
                                   group="media"
                                   handle=".app-tab-config-element-heading"
                                   ghost-class="app-tab-config-element-ghost"
                                   :force-fallback="true"
                                   :fallback-tolerance="5"
                                   :scroll-sensitivity="100"
                                   :animation="150"
                                   @start="dragging = true"
                                   @end="onDragEnd"
                                   tag="div">
                            <div v-for="(element,index) in record.elements" :key="element.id || element.key">
                                <app-tab-config-element-form :index="index"
                                                             :dragging="dragging"
                                                             :app-tab-config="record"
                                                             :categories="categories"
                                                             :static-information-pages="staticInformationPages"
                                                             :universal-sliders="universalSliders"
                                                             :customer-variables="customerVariables"
                                                             :customer-variables-translations="customerVariablesTranslations"
                                                             :record="element"
                                                             :isAdmin="isAdmin">
                                </app-tab-config-element-form>
                            </div>
                        </draggable>
                    </div>
                    <br>
                    <div class="col-md-12 form-group">
                        <button type="button" class="btn btn-success col-md-12" @click="addNewElement"
                                :disabled="!record.name">
                            <i class="fa fa-plus"></i> Neues Element hinzufügen
                        </button>
                    </div>
                    <br>
                    <br>
                    <br>
                </div>

                <div class="ibox-footer">
                    <button type="button" class="btn btn-secondary" @click="submit" :disabled="!record.name">
                        Speichern
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Modal from "../common/modal/Modal";
import VueToastr from "vue-toastr";
import Spinner from "../common/spinner/Spinner";
import AppTabConfigElementForm from "./AppTabConfigElementForm.vue";
import draggable from 'vuedraggable'

export default {
    name: 'AppTabConfigForm',
    components: {
        AppTabConfigElementForm,
        Spinner,
        Modal,
        VueToastr,
        draggable
    },
    methods: {
        addNewElement() {
            this.record.elements.push({
                key: 'new-' + Date.now(),
                name: 'Neues Element',
                display_name: 'Neues Element',
                module: 'FeedHeadlineModule',
                list_module: 'ListHeadline',
                title: 'Neues Element',
                text: '',
                external_link: '',
                link: '',
                icon: '',
                show_salutation: true,
                show_first_name: true,
                show_last_name: true,
                show_link: true,
                slider_count: 5,
                link_type: 'internal'
            });
            this.$forceUpdate();
            this.$parent.$forceUpdate();
        },
        onDragEnd() {
            // Reset after the click that follows mouseup, so the dropped element does not toggle
            setTimeout(() => this.dragging = false);
        },
        changeType(value) {
            if (this.record.elements.length > 0) {
                if (confirm("Wenn Sie den Typen des Breichs ändern, werden die bestehenden Elemente gelöscht, da sie inkompatibel sind. Möchten Sie wirklich fortfahren?")) {
                    this.record.elements = [];
                } else {
                    this.record.type = (value === 'feed' ? 'list' : 'feed');
                }
            }
            this.$forceUpdate();
        },
        submit() {
            if (this.record.client_id == null) {
                return; //TODO: Message to user
            }

            console.log(this.record)

            axios.patch('/backend/app_tab_configs/' + this.record.id, this.record)
                .then(res => {
                    window.location = '/backend/app_tab_configs';
                })
                .catch(res => console.log(res));
        },
    },
    data() {
        return {
            record: null,
            dragging: false,
        };
    },
    props: ['clients', 'isAdmin', 'dbRecord', 'user', 'title', 'disabled', 'categories', 'universalSliders', 'staticInformationPages', 'customerVariables', 'customerVariablesTranslations'],
    mounted() {
        this.record = this.dbRecord;
        if (!Array.isArray(this.record.elements) || this.record.elements === 0) this.record.elements = [];
        this.$parent.$forceUpdate();
        this.$forceUpdate();
    }
}
</script>

<style>
.app-tab-config-element-ghost {
    opacity: 0.4;
}
</style>